module.exports = __webpack_public_path__ + "media/images/jamicons/info-399d492c739617383bcffd5e2cc22ca7.svg";